import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "../MapContainer";
import { Card, CardHeader, CardContent, Button } from "@material-ui/core";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";

import "../imgDiv.css";
class JcVehicleChecklist extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: []
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderSigs(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;

        return (
            <Card>
                <CardHeader title={"Vehicle Checklist"} />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={el => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}

                            {/* <Typography variant="heading">
                                Vehicle Checklist No:
                                {report.urn === undefined ? "N/A" : report.urn}
                            </Typography> */}

                            <div style={{ width: "100%" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Information</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Name:</b>
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        {/* <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Email:</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div> */}
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Email:</b>
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            {report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Form Created: </b>
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13, true)}>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Vehicle Reg. Number </b>
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13, true)}>
                                            {report.vehicle_reg
                                                ? report.vehicle_reg
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Longitude: </b>
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13, true)}>
                                            {report.location_lon
                                                ? report.location_lon
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Latitude: </b>
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13, true)}>
                                            {report.location_lat
                                                ? report.location_lat
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "30%",
                                        float: "left",
                                        marginLeft: "2%"
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(21, 8)}>
                                    <div
                                        style={cstyle(1, 1, 1, 8, false, true)}
                                    >
                                        <b>Checks</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2, true)}>
                                        <b>Check</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 3, true)}>
                                        <b>Yes/No</b>
                                    </div>

                                    <div style={cstyle(2, 3, 2, 8, true)}>
                                        <b>Comments:</b>
                                    </div>
                                    <div style={cstyle(3, 1, 3, 2, true)}>
                                        <b>
                                            1/ Tyre Check and Wheel Condition
                                            Compliant?
                                        </b>
                                    </div>
                                    <div style={cstyle(3, 2, 3, 3, true)}>
                                        {report.insp_1_status
                                            ? report.insp_1_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(3, 3, 3, 8, true)}>
                                        {report.insp_1_comment
                                            ? report.insp_1_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(4, 1, 4, 2, true)}>
                                        <b>
                                            2/ Brakes/ABS/EBS Warning Lights
                                            Showing?
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 2, 4, 3, true)}>
                                        {report.insp_2_status
                                            ? report.insp_2_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(4, 3, 4, 8, true)}>
                                        {report.insp_2_comment
                                            ? report.insp_2_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 2, true)}>
                                        <b>
                                            3/ All Gauges, Instruments Working
                                            Correctly?
                                        </b>
                                    </div>
                                    <div style={cstyle(5, 2, 5, 3, true)}>
                                        {report.insp_3_status
                                            ? report.insp_3_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(5, 3, 5, 8, true)}>
                                        {report.insp_3_comment
                                            ? report.insp_3_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(6, 1, 6, 2, true)}>
                                        <b>
                                            4/ Mirrors (All Mirrors) Clean and
                                            OK
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 2, 6, 3, true)}>
                                        {report.insp_4_status
                                            ? report.insp_4_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(6, 3, 6, 8, true)}>
                                        {report.insp_4_comment
                                            ? report.insp_4_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(7, 1, 7, 2, true)}>
                                        <b>
                                            5/ Wipers and Windscreen Washer
                                            Fluid
                                        </b>
                                    </div>
                                    <div style={cstyle(7, 2, 7, 3, true)}>
                                        {report.insp_5_status
                                            ? report.insp_5_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(7, 3, 7, 8, true)}>
                                        {report.insp_5_comment
                                            ? report.insp_5_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(8, 1, 8, 2, true)}>
                                        <b>
                                            6/ Windscreen/Cab Glass Clear From
                                            Obstruction
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 2, 8, 3, true)}>
                                        {report.insp_6_status
                                            ? report.insp_6_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(8, 3, 8, 8, true)}>
                                        {report.insp_6_comment
                                            ? report.insp_6_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(9, 1, 9, 2, true)}>
                                        <b>7/ Vehicle Clean and Washed</b>
                                    </div>
                                    <div style={cstyle(9, 2, 9, 3, true)}>
                                        {report.insp_7_status
                                            ? report.insp_7_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(9, 3, 9, 8, true)}>
                                        {report.insp_7_comment
                                            ? report.insp_7_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(10, 1, 10, 2, true)}>
                                        <b>
                                            8/ Doors (Locked, Opening And
                                            Closing Correctly)
                                        </b>
                                    </div>
                                    <div style={cstyle(10, 2, 10, 3, true)}>
                                        {report.insp_8_status
                                            ? report.insp_8_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(10, 3, 10, 8, true)}>
                                        {report.insp_8_comment
                                            ? report.insp_8_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(11, 1, 11, 2, true)}>
                                        <b>9/ Body Work</b>
                                    </div>
                                    <div style={cstyle(11, 2, 11, 3, true)}>
                                        {report.insp_9_status
                                            ? report.insp_9_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(11, 3, 11, 8, true)}>
                                        {report.insp_9_comment
                                            ? report.insp_9_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(12, 1, 12, 2, true)}>
                                        <b>10/ Engine and Clutch</b>
                                    </div>
                                    <div style={cstyle(12, 2, 12, 3, true)}>
                                        {report.insp_10_status
                                            ? report.insp_10_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(12, 3, 12, 8, true)}>
                                        {report.insp_10_comment
                                            ? report.insp_10_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(13, 1, 13, 2, true)}>
                                        <b>11/ Equipement Secure</b>
                                    </div>
                                    <div style={cstyle(13, 2, 13, 3, true)}>
                                        {report.insp_11_status
                                            ? report.insp_11_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(13, 3, 13, 8, true)}>
                                        {report.insp_11_comment
                                            ? report.insp_11_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(14, 1, 14, 2, true)}>
                                        <b>
                                            12/ Vehicle Sitting Square (Not
                                            Leaning)
                                        </b>
                                    </div>
                                    <div style={cstyle(14, 2, 14, 3, true)}>
                                        {report.insp_12_status
                                            ? report.insp_12_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(14, 3, 14, 8, true)}>
                                        {report.insp_12_comment
                                            ? report.insp_12_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(15, 1, 15, 2, true)}>
                                        <b>13/ Hazard and Indicator Lights</b>
                                    </div>
                                    <div style={cstyle(15, 2, 15, 3, true)}>
                                        {report.insp_13_status
                                            ? report.insp_13_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(15, 3, 15, 8, true)}>
                                        {report.insp_13_comment
                                            ? report.insp_13_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(16, 1, 16, 2, true)}>
                                        <b>14/ Brake And Reversing Lights</b>
                                    </div>
                                    <div style={cstyle(16, 2, 16, 3, true)}>
                                        {report.insp_14_status
                                            ? report.insp_14_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(16, 3, 16, 8, true)}>
                                        {report.insp_14_comment
                                            ? report.insp_14_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(17, 1, 17, 2, true)}>
                                        <b>
                                            15/ Engine And Beacon Roof Lights
                                            and LED's on Front
                                        </b>
                                    </div>
                                    <div style={cstyle(17, 2, 17, 3, true)}>
                                        {report.insp_15_status
                                            ? report.insp_15_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(17, 3, 17, 8, true)}>
                                        {report.insp_15_comment
                                            ? report.insp_15_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(18, 1, 18, 2, true)}>
                                        <b>16/ Head And Fog Lights</b>
                                    </div>
                                    <div style={cstyle(18, 2, 18, 3, true)}>
                                        {report.insp_16_status
                                            ? report.insp_16_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(18, 3, 18, 8, true)}>
                                        {report.insp_16_comment
                                            ? report.insp_16_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(19, 1, 19, 2, true)}>
                                        <b>
                                            17/ Number Plate Front And Rear
                                            Lights
                                        </b>
                                    </div>
                                    <div style={cstyle(19, 2, 19, 3, true)}>
                                        {report.insp_17_status
                                            ? report.insp_17_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(19, 3, 19, 8, true)}>
                                        {report.insp_17_comment
                                            ? report.insp_17_comment
                                            : "N/A"}
                                    </div>

                                    <div style={cstyle(20, 1, 20, 2, true)}>
                                        <b>18/ Reflective Markings</b>
                                    </div>
                                    <div style={cstyle(20, 2, 20, 3, true)}>
                                        {report.insp_18_status
                                            ? report.insp_18_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(20, 3, 20, 8, true)}>
                                        {report.insp_18_comment
                                            ? report.insp_18_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(21, 1, 21, 2, true)}>
                                        <b>19/ Tax, Insurance And NCT Discs</b>
                                    </div>
                                    <div style={cstyle(21, 2, 21, 3, true)}>
                                        {report.insp_19_status
                                            ? report.insp_19_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(21, 3, 21, 8, true)}>
                                        {report.insp_19_comment
                                            ? report.insp_19_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(22, 1, 22, 2, true)}>
                                        <b>
                                            20/ Engine Oil, Water, And
                                            Windscreen Washer Reservoir
                                        </b>
                                    </div>
                                    <div style={cstyle(22, 2, 22, 3, true)}>
                                        {report.insp_20_status
                                            ? report.insp_20_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(22, 3, 22, 8, true)}>
                                        {report.insp_20_comment
                                            ? report.insp_20_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(23, 1, 23, 2, true)}>
                                        <b>21/ Fuel Level above 1/2</b>
                                    </div>
                                    <div style={cstyle(23, 2, 23, 3, true)}>
                                        {report.insp_21_status
                                            ? report.insp_21_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(23, 3, 23, 8, true)}>
                                        {report.insp_21_comment
                                            ? report.insp_21_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(24, 1, 24, 2, true)}>
                                        <b>
                                            22/ Seat Belts And Horn Operating
                                            Correctly
                                        </b>
                                    </div>
                                    <div style={cstyle(24, 2, 24, 3, true)}>
                                        {report.insp_22_status
                                            ? report.insp_22_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(24, 3, 24, 8)}>
                                        {report.insp_22_comment
                                            ? report.insp_22_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(25, 1, 25, 2, true)}>
                                        <b>23/ Audible Reversing Signal</b>
                                    </div>
                                    <div style={cstyle(25, 2, 25, 3, true)}>
                                        {report.insp_23_status
                                            ? report.insp_23_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(25, 3, 25, 8, true)}>
                                        {report.insp_23_comment
                                            ? report.insp_23_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(27, 1, 27, 2, true)}>
                                        <b>24/ Reversing camera (If Any)</b>
                                    </div>
                                    <div style={cstyle(27, 2, 27, 3, true)}>
                                        {report.insp_24_status
                                            ? report.insp_24_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(27, 3, 27, 8, true)}>
                                        {report.insp_24_comment
                                            ? report.insp_24_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(28, 1, 28, 2, true)}>
                                        <b>25/ Toolbox In And Equipped</b>
                                    </div>
                                    <div style={cstyle(28, 2, 28, 3, true)}>
                                        {report.insp_25_status
                                            ? report.insp_25_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(28, 3, 28, 8, true)}>
                                        {report.insp_25_comment
                                            ? report.insp_25_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(29, 1, 29, 2, true)}>
                                        <b>26/ Cones</b>
                                    </div>
                                    <div style={cstyle(29, 2, 29, 3, true)}>
                                        {report.insp_26_status
                                            ? report.insp_26_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(29, 3, 29, 8, true)}>
                                        {report.insp_26_comment
                                            ? report.insp_26_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(30, 1, 30, 2, true)}>
                                        <b>27/ Signs (Min 2 Roadworks Ahead)</b>
                                    </div>
                                    <div style={cstyle(30, 2, 30, 3, true)}>
                                        {report.insp_27_status
                                            ? report.insp_27_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(30, 3, 30, 8, true)}>
                                        {report.insp_27_comment
                                            ? report.insp_27_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(31, 1, 31, 2, true)}>
                                        <b>28/ Manhole Pry Bar</b>
                                    </div>
                                    <div style={cstyle(31, 2, 31, 3, true)}>
                                        {report.insp_28_status
                                            ? report.insp_28_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(31, 3, 31, 8, true)}>
                                        {report.insp_28_comment
                                            ? report.insp_28_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(32, 1, 32, 2, true)}>
                                        <b>
                                            29/ Grease Nipples/Grease Points
                                            Reservoir
                                        </b>
                                    </div>
                                    <div style={cstyle(32, 2, 32, 3, true)}>
                                        {report.insp_29_status
                                            ? report.insp_29_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(32, 3, 32, 8, true)}>
                                        {report.insp_29_comment
                                            ? report.insp_29_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(33, 1, 33, 2, true)}>
                                        <b>30/ Fire Extinguisher</b>
                                    </div>
                                    <div style={cstyle(33, 2, 33, 3, true)}>
                                        {report.insp_30_status
                                            ? report.insp_30_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(33, 3, 33, 8, true)}>
                                        {report.insp_30_comment
                                            ? report.insp_30_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(34, 1, 34, 2, true)}>
                                        <b>31/ First Aid Kit</b>
                                    </div>
                                    <div style={cstyle(34, 2, 34, 3, true)}>
                                        {report.insp_31_status
                                            ? report.insp_31_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(34, 3, 34, 8, true)}>
                                        {report.insp_31_comment
                                            ? report.insp_31_comment
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(35, 1, 35, 2, true)}>
                                        <b>32/ Super Structure</b>
                                    </div>
                                    <div style={cstyle(35, 2, 35, 3, true)}>
                                        {report.insp_32_status
                                            ? report.insp_32_status
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(35, 3, 35, 8, true)}>
                                        {report.insp_32_comment
                                            ? report.insp_32_comment
                                            : "N/A"}
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(5, 4, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Notes</b>
                                        </div>

                                        <div style={cstyle(2, 1, 5, 5, true)}>
                                            {report.notes
                                                ? report.notes
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>

                                <div style={gstyle(4, 9, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSigs(
                                            report.attached_signatures
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectCurrentReport(store)
        };
    },
    { getReport, getStandaloneReport }
)(JcVehicleChecklist);
